import * as types from 'root/modal/modalWindowActions';
import { ModalEnum } from 'myParkdUtils/enums';
import { REHYDRATE, RehydrateAction } from 'redux-persist';


export type ModalWindowState = {
    modalName: typeof ModalEnum | null
    modalData: any
}

const defaultState: ModalWindowState = {
    modalName: null,
    modalData: null
};


export default function modalWindow(state = defaultState, action: types.ModalWindowAction | RehydrateAction): ModalWindowState {
    switch (action.type) {

        case types.MODAL_WINDOW_UPDATE:
            return {
                ...state,
                modalName: action.payload.modalName,
                modalData: action.payload.modalData
            };

        case REHYDRATE:
            return {
                ...state
            };

        default:
            return state;
    }
}
